/**
 * Feature Registry
 *
 * Lightweight registry for platform features that can be gated by org entitlements.
 * Unlike agents, features don't have lazy-loaded components — they represent
 * capabilities controlled elsewhere (nav items, pages, etc.).
 */

export interface FeatureDefinition {
  /** URL-friendly slug — stored in agent_entitlements alongside agent slugs */
  slug: string;
  /** Display name shown in admin EntitlementsPanel */
  name: string;
  /** Short description shown in admin EntitlementsPanel */
  description: string;
  /** HeroIcon name (from react-icons/hi2) */
  icon: string;
  /** Whether the feature is available for entitlement (default: true) */
  enabled: boolean;
}

export const FEATURES: FeatureDefinition[] = [
  {
    slug: 'ask-kodi',
    name: 'Ask KODI',
    description: 'AI-powered conversational assistant',
    icon: 'HiChatBubbleLeftRight',
    enabled: true
  },
  {
    slug: 'reviews',
    name: 'Review',
    description: 'Review and analyze captured audio incidents',
    icon: 'HiClipboardDocumentCheck',
    enabled: true
  },
  {
    slug: 'send-message',
    name: 'Send Message',
    description: 'Send TTV messages to channels',
    icon: 'HiPaperAirplane',
    enabled: true
  },
  {
    slug: 'near-realtime-export',
    name: 'Near-Realtime Export',
    description: 'Deliver every matching message to a partner webhook in near-realtime',
    icon: 'HiBolt',
    enabled: true
  }
];

/**
 * Get all enabled features
 */
export function getEnabledFeatures(): FeatureDefinition[] {
  return FEATURES.filter((f) => f.enabled !== false);
}

/**
 * Get a feature by its slug (only if enabled)
 */
export function getFeatureBySlug(slug: string): FeatureDefinition | undefined {
  return FEATURES.find((f) => f.slug === slug && f.enabled !== false);
}
